import {
  ActualsValueTypes,
  DEFAULT_NETNDP,
  DEFAULT_NETNDP_DISTRIBUTOR,
  DEFAULT_NETNDP_RETAIL,
} from '../../models/actualValueTypes'

export const getActualsValueTypeDefault = (
  isRetailer: boolean,
  isDistributor: boolean
): ActualsValueTypes => {
  let defaultActualsValueType = isRetailer ? DEFAULT_NETNDP_RETAIL : DEFAULT_NETNDP
  if (isDistributor) {
    defaultActualsValueType = DEFAULT_NETNDP_DISTRIBUTOR
  }

  return defaultActualsValueType
}
